import reservationsService from "api/reservationsService"
import { AxiosResponse } from "axios"
import { useQuery } from "react-query"

const useGetCarWashDiscountTypes = (laundryId: number, enabled: boolean) => {
  return useQuery(
    ["reservation-get-car-wash-discount-types", laundryId],
    async () => {
      try {
        const res: AxiosResponse<any> =
          await reservationsService.getCarWashDiscountTypes(laundryId)
        return res.data
      } catch (err: any) {
        err.response
      }
    },
    { enabled },
  )
}

export default useGetCarWashDiscountTypes
